import { Injectable } from '@angular/core';
import { NavigationExtras, Router, UrlCreationOptions, UrlTree } from '@angular/router';
import { PathRouter } from './model/typed-router.model';

@Injectable({ providedIn: 'root' })
export class ElioTypedRouter {
  readonly events = this.router.events;
  readonly url = this.router.url;

  constructor(private router: Router) {}

  navigate(commands: PathRouter[], extras?: NavigationExtras): Promise<boolean> {
    return this.router.navigate(commands, extras);
  }

  createUrlTree(commands: PathRouter[], navigationExtras?: UrlCreationOptions): UrlTree {
    return this.router.createUrlTree(commands, navigationExtras);
  }

  parseUrl(url: PathRouter[]): UrlTree {
    return this.router.parseUrl(url.join('/'));
  }
}
